import { render, staticRenderFns } from "./battleCaseDetail.vue?vue&type=template&id=5af79102&scoped=true&"
import script from "./battleCaseDetail.vue?vue&type=script&lang=js&"
export * from "./battleCaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./battleCaseDetail.vue?vue&type=style&index=0&id=5af79102&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af79102",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5af79102')) {
      api.createRecord('5af79102', component.options)
    } else {
      api.reload('5af79102', component.options)
    }
    module.hot.accept("./battleCaseDetail.vue?vue&type=template&id=5af79102&scoped=true&", function () {
      api.rerender('5af79102', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/battle/components/battleCaseDetail.vue"
export default component.exports